module.exports = __webpack_public_path__ + "img/close.24bad129.svg";